import ProfilePRP from './ProfilePRPContainer';

export default ProfilePRP;
